import  { reset } from 'redux-form'

import {
  AUTH_PROFILE_RECEIVE,
  CHANGE_PASSWORD_RECEIVE,
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  isNordEmployee
} from './authProfile'
export const PASSWORD_SHOW_DIALOG = 'changePasswordFormDialog/PASSWORD_SHOW_DIALOG'


const initialState = {
  initialValues: {},
  isSubmitting: false,
  open: false
}

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case AUTH_PROFILE_RECEIVE:
      const userInfo = action.payload
      return {
        ...state,
        initialValues: isNordEmployee(userInfo) ? { 
          email:  userInfo.email,
          firstName: userInfo.first_name,
          lastName: userInfo.last_name
        } : {
          email: userInfo.profile.email,
          firstName: userInfo.profile.firstName,
          lastName: userInfo.profile.lastName,
        }
          
      }
    case PASSWORD_SHOW_DIALOG:
      return {
        ...state,
        open: action.changePasswordDialogState,
      }
    case CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        isSubmitting: true
      }
    case CHANGE_PASSWORD_RECEIVE:
      return {
        ...state,
        isSubmitting: false,
        open: false
      }
    case CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        isSubmitting: false
      }
    default:
      return state
  }
}

export const resetPassForm = () => {
  return (dispatch) => {
    dispatch(reset('changePasswordFormDialog'))
  }
}

export const showPasswordDialog = (changePasswordDialogState) => ({ type: PASSWORD_SHOW_DIALOG, changePasswordDialogState } )

export default reducer
